import apiClient from './client'
import type { LineupSubmission, TourneyId, SuccessResponse, Lineup, LineupWithTournament } from '@/types/api'

export const lineupsApi = {
  // Submit lineup
  submitLineup: async (tourneyId: TourneyId, data: LineupSubmission): Promise<SuccessResponse> => {
    const response = await apiClient.post<SuccessResponse>(`/tournaments/${tourneyId}/lineups`, data)
    return response.data
  },

  // Get user's lineup for a specific tournament
  getUserLineup: async (tourneyId: TourneyId): Promise<Lineup | null> => {
    try {
      const response = await apiClient.get<Lineup>(`/tournaments/${tourneyId}/lineups/mine`)
      return response.data
    } catch (error) {
      // Return null if no lineup exists yet
      return null
    }
  },

  // Get all user's lineups across all tournaments (with tournament details)
  getAllMyLineups: async (): Promise<LineupWithTournament[]> => {
    const response = await apiClient.get<{ lineups: LineupWithTournament[] }>(`/lineups/my`)
    return response.data.lineups
  },
}
